const TickDouble02Icon = /*#__PURE__*/ [
  ["path", { d: "M2.5 13.8333L6 17.5L7.02402 16.4272M16.5 6.5L10.437 12.8517", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 13.8333L11 17.5L21.5 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { TickDouble02Icon as default };
//# sourceMappingURL=TickDouble02Icon.js.map
